<app-highcharts-render
    [loading]="loading"
    [options]="options"
    [visualization]="visualization"
    [series]="series"
    [points]="points"
></app-highcharts-render>
